import { request } from "../utils/request.js"

export const sysTask_findTaskIdList = (args) => request({
    url: 'sysTask/findTaskIdList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const sysTask_findPageForManage = (pojo, args) => request({
    url: 'sysTask/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const sysTask_findById = (id, args) => request({
    url: 'sysTask/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const sysTask_changeFrozenStatus = (id, args) => request({
    url: 'sysTask/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysTask_handleTask = (id, args) => request({
    url: 'sysTask/handleTask',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysTask_handleTaskAsync = (id, args) => request({
    url: 'sysTask/handleTaskAsync',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysTask_addNew = (pojo, args) => request({
    url: 'sysTask/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const sysTask_update = (pojo, args) => request({
    url: 'sysTask/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const sysTask_history_findByPage = (pojo, args) => request({
    url: 'sysTask/history/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/sysTask.js